import { FaReact } from "react-icons/fa";

function Dashboard() {
  return (
    <div className="sub-body">
      <h2 className="headings">Welcome to React Users</h2>
      <FaReact className="react-icon dashboard" />
    </div>
  );
}

export default Dashboard;
